<template>
  <section class="component-mini-quick-view-box">

    <app-loading :isFull="false" v-if="!item.id" />

    <div class="box-quick-view">
      <h5 class="text-right rtl mb-2">{{item.course_title}}</h5>
      <div class="regular  mb-3 d-flex  flex-column  justify-content-between">
        <div class="quick-view-regular mb-2">
          <i class="flaticon-play-1-circle"></i>
          <span>
            امکان دانلود ویدئوهای دوره : {{item.downloadable ? 'دارد' : 'ندارد'}}
          </span>
        </div>
        <div class="quick-view-regular mb-2">
          <i class="mdi mdi-clock"></i>
          <span>
            {{item.course_duration}} ساعت فیلم آموزشی
          </span>
        </div>
        <div class="quick-view-regular mb-2">
          <i class="mdi mdi-filter-variant"></i>
          <span>
            سطح : {{item.level | level}}
          </span>
        </div>
        <div class="quick-view-regular mb-2">
          <i class="mdi mdi-school"></i>
          <span>مدرس : {{item.fullname ? item.fullname : 'در حال بار گذاری ... '}} </span>
        </div>
      </div>
      <div class="short-description">
        <h4 class="font-16">توضیحات مختصر : </h4>
        <p class="text-justify font-12 rtl my-2" v-html="item.course_description_lite">
        </p>
        <!-- <ul class="text-right rtl">
          <li class="mb-2">
            <i class="mdi mdi-alert-circle-outline"></i>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
          </li>
          <li class="mb-2">
            <i class="mdi mdi-alert-circle-outline"></i>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
          </li>
          <li class="mb-2">
            <i class="mdi mdi-alert-circle-outline"></i>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
          </li>
        </ul> -->

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'quick-view-box',
  computed: {
    item () {
      return this.$store.state.courses.courseDetail
    }
  }
}
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
.component-mini-quick-view-box {
  .box-clear;
  min-height: 400px;
  h5 {
    font-size: 16px;
  }
  .regular {
    .quick-view-regular {
      i {
        font-size: 12px;
      }
      span {
        font-size: 14px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .short-description {
    p {
      font-size: 16px;
    }
    ul {
      li {
        font-size: 14px;
        color: #333;
        i {
          color: #222;
          &:before {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/min-component/quick-view-box.vue